@if (notice) {
  <div [innerHTML]="notice.message"></div>
  <div class="tw:leading-none">
    <svg
      cfIcon="close"
      class="tw:cursor-pointer tw:text-white tw:ml-6"
      cfDebounceClick
      (debounceClick)="emitDismiss.emit()"
      [class.disabled]="loadingService.loadingState$ | async"
    ></svg>
  </div>
}
